import '..';
import '../articles';
import '../js/tabs';
import '../js/popup';
import '../js/custom-scrollbar';



// WEBPACK FOOTER //
// ./frontend/entries/articles.js